import styled from 'styled-components'
import { PositiveIcon } from '@shipt/design-system-icons'
import { Body } from '@shipt/design-system-typography'
import { type CouponClippedState } from '@/features/shop/services/Coupons/hooks'
import { range } from '@/features/shared/utils/range'

type Props = {
  coupon: { appliedProductQty: number }
  couponClippedState: CouponClippedState
}

export const CouponProgressCircles = ({ coupon, couponClippedState }: Props) => {
  const { appliedProductQty = 0 } = coupon
  const filledArray = range(appliedProductQty)
  const { isFulfilled, qualifiedProductIdsInOrder = [] } = couponClippedState
  return (
    <Wrapper>
      {filledArray.map((index) => {
        const couponNumber = index + 1
        const isApplied = qualifiedProductIdsInOrder.length >= couponNumber
        return (
          <ProgressCirclesWrapper strong size="md" key={index} data-is-applied={isApplied}>
            {isFulfilled ? <PositiveIcon surface="inverse" /> : couponNumber}
          </ProgressCirclesWrapper>
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
`

const ProgressCirclesWrapper = styled(Body)<{
  'data-is-applied': boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 8px;
  width: 28px;
  height: 28px;

  &:not([data-is-applied='true']) {
    color: ${({ theme }) => theme.gray300};
    border: 1px dashed ${({ theme }) => theme.orange700}50;
  }

  &[data-is-applied='true'] {
    color: ${({ theme }) => theme.white};
    background-color: ${({ theme }) => theme.orange700};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`
